import ScrollInView from "./components/scroll-in-view";
import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import ProductsSlider from "./components/products-slider";
import ProductThumbsSlider from "./components/product-thumbs-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import ColumnCount from "./components/column-count";
import DeviceManager from "./utils/device-manager";
import Tabs from "./components/tabs";
import ProductImages from "./components/product-images";
import RelatedProductsSlider from "./components/related-products-slider"
import MultipleSelect from "./components/multiple-select";
import GallerySlider from "./components/gallery-slider";

(function ($) {
	window.$ = $;

	$(function () {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}

		// General components
		const langSelector = new LangSelector($(".language-selector"));
		const siteHeader = new SiteHeader($(".site-header"), 20);
		// const dropdownMenu = new DropdownMenu($('.header__nav'));


		//	Related product slider
		const $relatedProductsSlider = $(".related-products");
		if ($relatedProductsSlider.length) {
			$relatedProductsSlider.each(function (index, el) {
				const relatedProductsSlider = new RelatedProductsSlider($(el));
			});
		}

		// Home slider component
		const $homesSliders = $(".home-slider");
		if ($homesSliders.length) {
			$homesSliders.each(function (index, el) {
				const homeSlider = new HomeSlider($(el));
			});
		}

		// Gallery slider component
		const $gallerySliders = $(".home-social__gallery");
		if ($gallerySliders.length) {
			$gallerySliders.each(function (index, el) {
				const gallerySlider = new GallerySlider($(el));
			});
		}

		// Products slider component
		const $productsSliders = $(".products-slider");
		if ($productsSliders.length) {
			$productsSliders.each(function (index, el) {
				const productSlider = new ProductsSlider($(el));
			});
		}

		// Products thumbnails slider component
		const $productthumbsSliders = $(".product-images__thumbnails");
		if ($productthumbsSliders.length) {
			$productthumbsSliders.each(function (index, el) {
				const productthumbSlider = new ProductThumbsSlider($(el));
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}

		// Input type submit in newsletter wrap into a snap
		let input = $('.site-header__newsletter input.gform_button');
		input.wrap('<span class=wrap-input></span>');

		//Remove the label for the newsletter form on focus 
		$(".site-header__newsletter input").focus(function() {
			$(this).parent().prev('label').hide();
		});
		$(".site-header__newsletter input").focusout(function() {
			$(this).val('');
			$(this).parent().prev('label').show();
		});
	});
})(jQuery);
